<template>
    <b-row class="bg-white d-flex">
        <!-- justify-content-around -->
        <b-col cols="4">
            <fieldset class="filter-box-coupon-reports w-100">
                <legend class="filter-text">{{ $t('report.coupon_ft_parent_code') }}</legend>
                <multiselect 
                    v-model="parentCouponCode"  
                    :options="parentCouponOptions"  
                    label="code" 
                    track-by="id"
                    :multiple="false"
                    :show-labels="false"
                    :placeholder="$t('report.select_option')"
                    >
                </multiselect>
            </fieldset>
        </b-col>

        <b-col cols="4">
            <fieldset class="filter-box-coupon-reports w-100">
                <legend class="filter-text">{{ $t('report.coupon_ft_store_code_and_name') }}</legend>
                <multiselect 
                    v-model="storeCode" 
                    :options="storeOptions"  
                    label="full_name_en" 
                    track-by="code"
                    :multiple="false"
                    :show-labels="false"
                    :placeholder="$t('report.select_option')"
                    >
                </multiselect>
            </fieldset>
        </b-col>

        <b-col cols="2">
            <fieldset class="filter-box-coupon-reports w-100">
                <legend class="filter-text">{{ $t('report.coupon_ft_type_code') }}</legend>
                <multiselect 
                    v-model="couponTypeCode" 
                    :options="couponTypeOptions"  
                    label="name_en" 
                    track-by="id"
                    :multiple="false"
                    :show-labels="false"
                    :placeholder="$t('report.select_option')"
                    >
                </multiselect>
            </fieldset>
        </b-col>

        <b-col cols="2">
            <fieldset class="filter-box-coupon-reports w-100">
                <legend class="filter-text">{{ $t('report.coupon_ft_customer_email') }}</legend>
                <md-field class="customer-email-input">
                    <md-input v-model="customerEmail"></md-input>
                </md-field>
            </fieldset>
        </b-col>
      </b-row>
    
</template>

<script>
import Multiselect from 'vue-multiselect'
const MAX_DEBOUNCE_MILISECONDS = 2000

export default {
    components: {
        Multiselect
    },
    data() {
        return {
            parentCouponCode: '',
            parentCouponOptions: [],
            storeCode: '',
            storeOptions: [],
            couponTypeCode: '',
            couponTypeOptions: [],
            customerEmail: '',
            debouncedInput: null
        }
    },
    created() {
        this.debouncedInput = _.debounce(this.handleEvent, MAX_DEBOUNCE_MILISECONDS);
        this.fetchAllMasterData()
    },
    methods: {
        storeCodeAndNameText (item) {
            return `${item.code} - ${item.name.en}`
        },
        couponTypeText (item) {
            return item.name.en
        },
        handleEvent() {
            const data = {
                customerEmail: this.customerEmail.toLowerCase(),
                parentCouponCode: (this.parentCouponCode.code!=undefined)?this.parentCouponCode.code:'',
                storeCode: (this.storeCode.code!=undefined)?this.storeCode.code:'',
                couponTypeCode: (this.couponTypeCode.id!=undefined)?this.couponTypeCode.id:''
            }
            this.$emit('onChange', data)
        },
        fetchAllMasterData() {
            this.axios.coupon.getAllParentCoupons(response => {
                this.parentCouponOptions = response.data.data.items
            })

            this.axios.coupon.getAllCouponTypes(response => {
                this.couponTypeOptions = response.data.data.items;
                this.couponTypeOptions.map(item => {
                    item.name_en = item.name.en
                })
            })

            this.axios.outlet.getOutletList('?limit=9999&active=1', {}, response => {
                this.storeOptions = response.data.data.items;
                this.storeOptions.map(item => {
                    item.full_name_en = `${item.code} - ${item.name.en}`
                })
            })
        }
    },
    watch: {
        'customerEmail': function (item) {
            if (item == null) {
                this.customerEmail = '';
            }
            this.handleEvent()
        },
        'couponTypeCode': function (item) {
            if(item==null) {
                this.couponTypeCode = '';
            }
            this.handleEvent()
        },
        'storeCode': function (item) {
            if(item==null) {
                this.storeCode = '';
            }
            this.handleEvent()
        },
        'parentCouponCode': function (item) {
            if(item==null) {
                this.parentCouponCode = '';
            }
            this.handleEvent()
        }
    }
}
</script>

<style scoped>
    .filter-box {
        box-shadow: 0 3px 1px -2px rgb(0 0 0 / 20%), 0 2px 2px 0 rgb(0 0 0 / 14%), 0 1px 5px 0 rgb(0 0 0 / 12%);
    }

    .filter-box .selection.dropdown {
        border: none;
        border-bottom: 1px solid rgba(34,36,38,.15);
        border-radius: 0;
    }

    .filter-box .selection.dropdown.visible {
        border: 1px solid #96c8da;
    }

    .customer-email-input {
        min-height: 42px;
        margin: 0;
        padding: 0;
    }

    .customer-email-input::after {
        background-color: transparent !important;
    }

    .customer-email-input::before {
        background-color: #4dbd74 !important;
    }

    .customer-email-input input::-webkit-input-placeholder {
        font-size: 14px;
        color: hsla(0,0%,74.9%,.87);
    }
    .filter-box-coupon-reports {
        border: 1px solid #00000026;
        border-radius: 3px;
        /* margin-top: 10px; */
        width: max-content;
    }
    .filter-text {
        font-size: 12px;
        margin-left: 10px;
        width: max-content;
        color:#6B6E79;
        margin-bottom: -3px;
    }

</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .coupon-report-list .multiselect__tags{
        border: none !important;
    }
</style>


// WEBPACK FOOTER //
// src/views/admin/report/components/FilterComponent.vue